import React, { useEffect } from 'react';
import '../css/Home.css';

const Home = () => {
  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      const photo = document.querySelector('.photo-container');
      const infoRectangle = document.querySelector('.info-rectangle');

      // Effet parallax sur la photo
      if (photo) {
        photo.style.transform = `translateY(${scrollPosition * 0.8}px)`;
      }

      // Effet d'apparition et parallax sur le rectangle d'information
      if (infoRectangle) {
        const rectPosition = infoRectangle.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;

        if (rectPosition < windowHeight) {
          infoRectangle.style.opacity = 1;
          infoRectangle.style.transform = `translateY(${scrollPosition * 0.5}px)`;
        } else {
          infoRectangle.style.opacity = 0;
          infoRectangle.style.transform = 'translateY(50px)';
        }
      }
    };

    window.addEventListener('scroll', handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <section id="home" className="home-section">
      <div className="home-content">
        <div className="vertical-line"></div>
        <div className="horizontal-line"></div>
        <h1 className="first-name">ISAAC</h1>
        <h1 className="last-name">NARANJO</h1>
        <h2 className="job-title">Junior Dev</h2>
        <div className="photo-container">
          <img
            src={require('../images/IN.jpg')}
            alt="Isaac Naranjo"
            className="profile-photo"
          />
        </div>

          {/* Nouveau rectangle pour les informations */}
          <div className="info-rectangle">
            <p>Actuellement étudiant à l'école 42 Lausanne, je suis passionné par l'informatique et je travaille activement à améliorer mes compétences techniques et pratiques. Au quotidien, je participe à des projets variés qui me permettent de :</p>
            <ul>
              <li>Corriger et optimiser du code pour améliorer la performance et la maintenabilité des projets.</li>
              <li>Proposer des solutions innovantes et créatives pour résoudre des problèmes complexes.</li>
              <li>Modifier et adapter des programmes en fonction des besoins spécifiques du projet et des retours d'expérience.</li>
              <li>Améliorer la qualité et l'efficacité du code en appliquant les bonnes pratiques de développement.</li>
            </ul>
            <p>Mon parcours à l'école 42 est basé sur l'apprentissage par la pratique, en collaborant avec d'autres étudiants sur des projets concrets, ce qui m'a permis de développer une solide capacité à résoudre des problèmes techniques tout en restant adaptable et curieux face aux nouveaux défis.</p>
            {/* Image qui apparaît au survol */}
          <img src={require('../images/42.png')} alt="Exemple" className="hover-image" />
          </div>

          {/* Square main F**/}
          <svg width="120%" height="43%">
          <svg preserveAspectRatio="xMidYMid meet" viewBox="0 0 100 100" width="50%" height="50%" x="50%" y="25%" overflow="visible">
          <g stroke="none" fill="none">
          <rect></rect>
          <rect></rect>
          <rect></rect>
          <rect></rect>
          </g>

          <g stroke="none" fill="none">
           <rect></rect>
          <rect></rect>
          <rect></rect>
         <rect></rect>
          </g>
         </svg>
       </svg>

        </div>
      </section>
    );
};

export default Home;
